<template>
  <div>

    <p v-if="this.inline">
      <code :class="this.languageClass">
        <slot></slot>
      </code>
    </p>
    <div v-else>
      <slot></slot>
    </div>
    <!-- <pre
      v-else
      :class="this.languageClass"
    >
      <code :class="this.languageClass">
        <slot></slot>
      </code>
    </pre> -->

  </div>
</template>

<script>

import Prism from 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';

export default {
  name: 'Code',
  props: {
    language: {
      required: true,
      default: 'js',
    },
    inline: {
      required: false,
      default: false,
    },
  },
  data() {
    return {

    };
  },
  computed: {
    languageClass() {
      return `language-${this.language}`;
    },
  },
  mounted() {
    Prism.highlightAll();
  },
};
</script>
<style>


</style>
